/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

import CheckboxButton from "./components/CheckboxButton/CheckboxButton";
import RadioButton from "./components/RadioButton/RadioButton";
import InputText from "./components/InputText/InputText";
import FormTitle from "./components/FormTitle";
import BottomButtonsGroup from "./components/BottomButtonsGroup";
import ContentOnly from "./components/MainGroupTitle/";
import Select from "./components/Select/index.js";
import SelectGroup from "./components/SelectGroup";
import InputOfficePhone from './components/InputOfficePhone';
import InputMobile from './components/InputMobile/';
import ItemTitle from './components/ItemTitle';
import DividingLine from './components/DividingLine';
import MsgBox from './components/MsgBox';
import DateField from './components/DateField';
import CombinedGroup from './components/CombinedGroup';
import InputWithPrefixSuffix from './components/InputWithPrefixSuffix';
import EmailGroup from './components/EmailGroup';
import MailAddressGroup from './components/MailAddressGroup';
import CaptionBox from './components/CaptionBox';
import RegionProportional from './components/RegionProportional';
import Region from './components/Region';
import PanelGroupForm from './components/PanelGroup/index';
import PopupModel from './components/PopupModel';
import Textarea from './components/Textarea';
import MainGroupTitle from './components/MainGroupTitle';
import SubGroupTitle from './components/SubGroupTitle';
import ErrorAtTop from './components/ErrorAtTop';
import CommonText from './components/ContentOnly';
import TextOnly from './components/TextOnly';
import CheckboxforInput from './components/CheckboxforInput/CheckboxforInput';

export default {
  CheckboxforInput,
  TextOnly,
  CheckboxButton,
  RadioButton,
  InputText,
  FormTitle,
  BottomButtonsGroup,
  Select,
  SelectGroup,
  InputOfficePhone,
  InputMobile,
  ItemTitle,
  DividingLine,
  MsgBox,
  DateField,
  CombinedGroup,
  InputWithPrefixSuffix,
  EmailGroup,
  MailAddressGroup,
  CaptionBox,
  RegionProportional,
  Region,
  PanelGroupForm,
  PopupModel,
  Textarea,
  ContentOnly,
  MainGroupTitle,
  SubGroupTitle,
  ErrorAtTop,
  CommonText,
}


// WEBPACK FOOTER //
// ./src/shared/AOForm/index.js